import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';
import { URLUtils } from '../../utils';
import { SearchService } from '../../services';
import { SearchPropDefault } from '../../models';

const getGeoLocations = ({ geoLocations, allowCitiesWithoutIata, activeProduct }) => ({ geoLocations, allowCitiesWithoutIata, activeProduct });

export const getGeoLocatedSearch = createSelector(
    [getGeoLocations],
    ({ geoLocations, allowCitiesWithoutIata, activeProduct }) => {
        const params = URLUtils.getHomeHashParams();
        let completed = SearchPropDefault;
        if (!isEmpty(params) && !isEmpty(geoLocations)) {
            let data = SearchService.searchParamsParser(params, activeProduct);
            completed = Object.assign({}, data);
            completed.segments.forEach((segment) => {
                Object.keys(segment).forEach((key) => {
                    if (key === 'origin' || key === 'destination') {
                        const fullData = geoLocations[segment[key].iata] ||
                            (allowCitiesWithoutIata && geoLocations[segment[key].geoNodeId]);
                        if (fullData) {
                            segment[key] = fullData;
                        } else {
                            delete segment[key];
                        }
                    }
                });
            });
        }
        return completed;
    }
);
